import React from "react";
import ReactDOM from "react-dom";

import "@/config";

import ApplicationArea from "@/components/application-area";
import offlineListener from "@/services/offline-listener";
import { ThemeProvider } from "@/components/ThemeProvider";

const App = () => {
  return (
    <ThemeProvider>
      <ApplicationArea />
    </ThemeProvider>
  );
};

ReactDOM.render(<App />, document.getElementById("application-root"), () => {
  offlineListener.init();
});
